const firebaseConfig = {
    apiKey: "AIzaSyDds2hEgE91jUkzLa1OBeRTh2sYwckuD4M",
    authDomain: "sunglass-shop-88af7.firebaseapp.com",
    projectId: "sunglass-shop-88af7",
    storageBucket: "sunglass-shop-88af7.appspot.com",
    messagingSenderId: "463697602257",
    appId: "1:463697602257:web:1c3604c5c93074ce2707f0"
  };
  export default firebaseConfig;